export default __webpack_public_path__ + "static/media/602.678392dd.gif";